export default {"src":"/_next/static/media/PoolBlueGrass.f3523b1d.svg","height":48,"width":263,"blurWidth":0,"blurHeight":0};